<el-icon class="rct-icon" v-bind="$props"><svg v-if="name"><use :xlink:href="'#' + finalName"></use></svg><slot v-else></slot></el-icon>